export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR";

//Email token verification
export const EMAIL_PASSWORD_RESET_TOKEN_VALIDATION =
  "EMAIL_PASSWORD_RESET_TOKEN_VALIDATION";
export const EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_SUCCESS =
  "EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_SUCCESS";
export const EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_ERROR =
  "EMAIL_PASSWORD_RESET_TOKEN_VALIDATION_ERROR";

// Change Old password to new password
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
